import axios from 'axios';

const apiUrl = process.env.VUE_APP_API_URL;

// Kept separate from api.js on purpose: adminApi.js already exports a `getNotifications`
// method for the existing site-banner texts (App\Models\Notification, see Header.vue's
// highlighted/general_text chip) — the plain `/notifications` path was already taken by
// that unrelated feature, which is also why the backend route base is `/user-notifications`.
// Merging this module into api.js's spread export would still silently shadow that method,
// so it's imported directly wherever it's needed, the same way store/index.js already
// imports dictionaryApi/adminApi directly.

// The endpoint takes flat query params (tab, type[], search, date_from, date_to, sort,
// page) rather than the JSON-blob `filters` param the older list endpoints use, so the
// params are built manually instead of relying on axios' shared paramsSerializer.
function buildParams(payload = {}) {
  const params = new URLSearchParams();
  if (payload.tab) params.append('tab', payload.tab);
  (payload.type || []).forEach((type) => params.append('type[]', type));
  if (payload.search) params.append('search', payload.search);
  if (payload.date_from) params.append('date_from', payload.date_from);
  if (payload.date_to) params.append('date_to', payload.date_to);
  if (payload.sort) params.append('sort', payload.sort);
  if (payload.page) params.append('page', payload.page);
  if (payload.per_page) params.append('per_page', payload.per_page);
  return params.toString();
}

export default {
  getNotifications: (payload, config) => axios.get(`${apiUrl}/user-notifications?${buildParams(payload)}`, config),
  getUnreadCount: (config) => axios.get(`${apiUrl}/user-notifications/unread-count`, config),
  markNotificationRead: (id) => axios.post(`${apiUrl}/user-notifications/${id}/read`),
  markNotificationUnread: (id) => axios.post(`${apiUrl}/user-notifications/${id}/unread`),
  markAllNotificationsRead: () => axios.post(`${apiUrl}/user-notifications/read-all`),
  deleteNotification: (id) => axios.delete(`${apiUrl}/user-notifications/${id}`),
  getNotificationPreferences: (config) => axios.get(`${apiUrl}/user-notifications/preferences`, config),
  updateNotificationPreferences: (payload, config) => axios.put(`${apiUrl}/user-notifications/preferences`, payload, config),
};
